import Section1 from 'containers/Section1';
import Section2 from 'containers/Section2';
import Section3 from 'containers/Section3';
import Section7 from 'containers/Section7';

import Section8 from 'containers/Section8';

import React from 'react';
import { Box } from '@mui/material';

export default function HomePage() {
  return (
    <Box>
      <Section1 />
      <Section2 />
      <Section3 />
      {/* <Section4 /> */}
      <Section7 />

      {/* <Section5 /> */}
      {/* <Section6 /> */}
      <Section8 />
      {/* <Section9 /> */}
    </Box>
  );
}
